import { memo } from "react";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";
import FaqSpotlight from "app/pages/Faq/FaqSpotlight/FaqSpotlight";
import "./FaqHome.scss";
import FaqHomeCategories from "app/pages/Faq/FaqHome/FaqHomeCategories/FaqHomeCategories";
import FaqFeaturedArticles from "app/pages/Faq/FaqHome/FaqFeaturedArticles/FaqFeaturedArticles";

const FaqHome = ({ faqCategories = [], faqSpotlight = {} }) => {
	return (
		<div className="faq-home">
			{!isEmpty(faqSpotlight) && (
				<div className="faq-home__spotlight">
					<FaqSpotlight
						articles={faqSpotlight.articles}
						message={faqSpotlight.message}
						title={faqSpotlight.title}
					/>
				</div>
			)}

			<div className="faq-home__nav">
				<FaqHomeCategories categories={faqCategories} />
			</div>

			<FaqFeaturedArticles faqCategories={faqCategories} />
		</div>
	);
};

FaqHome.propTypes = {
	faqCategories: PropTypes.array,
	faqSpotlight: PropTypes.object,
};

export default memo(FaqHome);
